import { IClauseChecklist, IOrganizationClauseChecklist } from "@/api";
import { Typography } from "@mui/material";
import { LinkRouter } from "../../../shared/buttons/LinkRouter";

interface IProps {
    /**
     * The clause checklist to display the title for.
     */
    clauseChecklist: IClauseChecklist | IOrganizationClauseChecklist;
}

/**
 * The title cell for a clause checklist.
 *
 * This cell is a link to the clause checklist details page.
 */
export const ClauseChecklistTitleCell = ({ clauseChecklist }: IProps) => {
    return (
        <LinkRouter to={`/admin/checklists/${clauseChecklist.id}/details`}>
            <Typography color={"primary"} variant="body2" fontWeight={600}>
                {clauseChecklist.name}
            </Typography>
        </LinkRouter>
    );
};
